// File-type helpers for the in-app preview (image / pdf / office).
export const isImageFile = (f) => (f?.type || '').startsWith('image/') || /\.(png|jpe?g|gif|webp|svg|bmp|avif)$/i.test(f?.name || '');
export const isPdfFile = (f) => (f?.type || '') === 'application/pdf' || /\.pdf$/i.test(f?.name || '');
export const isOfficeFile = (f) => /\.(docx?|xlsx?|pptx?)$/i.test(f?.name || '');
// Resolve a relative storage url (the shim returns `/storage/v1/object/public/…`
// when no absolute base is configured) to an absolute one, so the Office Online
// viewer — which fetches the file from Microsoft's servers — gets a real url.
export const toAbsoluteUrl = (u) => {
    if (!u) return u;
    if (/^https?:\/\//i.test(u)) return u;
    if (typeof window !== 'undefined' && u.startsWith('/')) return `${window.location.origin}${u}`;
    return u;
};
export const canCheckFileAvailability = (u) => {
    const abs = toAbsoluteUrl(u);
    if (!abs) return true;
    if (typeof window === 'undefined') return false;
    try {
        const target = new URL(abs, window.location.origin);
        return target.origin === window.location.origin && target.pathname.includes('/storage/v1/object/public/');
    } catch {
        return false;
    }
};
// Office Online / Google viewers must fetch the file over the public internet,
// so they can't preview a localhost/LAN url — fall back to download there.
// (Evaluate the ABSOLUTE url: a relative `/storage/…` on a live https origin is
// public, but on localhost it is not.)
export const isLocalUrl = (u) => {
    const abs = toAbsoluteUrl(u);
    return !abs || abs.startsWith('/') || /^https?:\/\/(localhost|127\.|10\.|192\.168\.|0\.0\.0\.0)/i.test(abs);
};
export const isVideoFile = (f) => (f?.type || '').startsWith('video/') || /\.(mp4|webm|ogg|mov|m4v)$/i.test(f?.name || '');
export const canPreview = (f) => isImageFile(f) || isPdfFile(f) || isOfficeFile(f) || isVideoFile(f);
